module.exports = __webpack_public_path__ + "img/media_com.53de8ad5.png";